import { render, staticRenderFns } from "./OfertaUpDescuentosDefault.vue?vue&type=template&id=5e472e61&"
import script from "./OfertaUpDescuentosDefault.vue?vue&type=script&lang=js&"
export * from "./OfertaUpDescuentosDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\simulador_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e472e61')) {
      api.createRecord('5e472e61', component.options)
    } else {
      api.reload('5e472e61', component.options)
    }
    module.hot.accept("./OfertaUpDescuentosDefault.vue?vue&type=template&id=5e472e61&", function () {
      api.rerender('5e472e61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Ofertas/defaults/partsDescuentos/OfertaUpDescuentosDefault.vue"
export default component.exports